// Molecules
import M4SidebarMenu from "./components/molecules/sidebar-menu/sidebar-menu.vue";
import M4RecordCounter from "./components/molecules/record-counter/record-counter.vue";
import M4Table from "./components/molecules/table/table.vue";
import M4SummaryCard from "./components/molecules/summary-card/summary-card.vue";
//x import M4DatetimePicker from "./components/molecules/datetime-picker/datetime-picker.vue";
import M4Teaser from "./components/molecules/teaser/teaser.vue";
import M4NoteField from "./components/molecules/note-field/note-field.vue";
//x import M4AceEditor from "./components/molecules/ace-editor/ace-editor.vue";
import M4SelectAction from "./components/molecules/select-action/select-action.vue";
import M4Select2Group from "./components/molecules/select2-group/select2-group.vue";
import M4TitleValueFieldGroup from "./components/molecules/title-value-field-group/title-value-field-group.vue";
import M4ValueFieldGroup from "./components/molecules/value-field-group/value-field-group.vue";

// Organisms
import M4TopLine from "./components/organisms/top-line/top-line.vue";
import M4Sidebar from "./components/organisms/sidebar/sidebar.vue";
import M4PaginatedTable from "./components/organisms/paginated-table/paginated-table.vue";
//x import M4ColumnChooser from "./components/organisms/column-chooser/column-chooser.vue";
import M4Breadcrumbs from "./components/organisms/breadcrumbs/breadcrumbs.vue";
import M4PermissionList from "./components/organisms/permission-list/permission-list.vue";
//x import M4JsonCompare from "./components/organisms/json-compare/json-compare.vue";

// Vue Plugin
const components = {
  // Atoms
  // Molecules
  M4SidebarMenu,
  M4RecordCounter,
  M4Table,
  M4SummaryCard,
  M4Teaser,
  M4SelectAction,
  M4Select2Group,
  //x M4DatetimePicker,
  //x M4AceEditor,
  M4TitleValueFieldGroup,
  M4ValueFieldGroup,
  M4NoteField,
  //
  // Organisms
  M4TopLine,
  M4Sidebar,
  //x M4ColumnChooser,
  M4Breadcrumbs,
  M4PermissionList,
  M4PaginatedTable
  //x M4JsonCompare
};
//
export default components;
